import axios, { AxiosRequestConfig } from 'axios'
import { CurrentUser, MFAResetLinkInput, User } from '../types'
import { setSession } from '../utils/jwt'
import createAPIClient from '../services/apiClient'
import SignUpInput from '../types/SignUpInput'
import { MFAType } from '../enums'
import { getTurnstileRequestConfig } from '../utils/turnstile'

// const login = async (email: string, password: string): Promise<CurrentUser> => {
//   try {
//     const response = await axios.post(baseUrl + 'login', { email, password })
//     return response.data
//   } catch (e) {
//     throw new Error('Wrong username or password')
//   }
// }

// const sendEmail = (email: string): Promise<AxiosResponse> => {
//   try {
//     const response = axios.post(baseUrl + 'email', { email })
//     return response
//   } catch (e) {
//     return e as never
//   }
// }

// const resetPassword = (
//   password: string,
//   token: string
// ): Promise<AxiosResponse> => {
//   try {
//     const response = axios.post(`${baseUrl}email/password_reset/${token}`, {
//       password
//     })
//     return response
//   } catch (e) {
//     return e as never
//   }
// }

// const changePassword = (
//   id: number,
//   oldPassword: string,

interface PassworInput {
  newPassword: string
  oldPassword?: string
}

interface EmailInput {
  email: string
}

interface LoginInput {
  email: string
  password: string
  token?: string
}

const api = axios.create({
  baseURL: import.meta.env.PROD
    ? import.meta.env.VITE_APP_PROD_API_URL
    : import.meta.env.VITE_APP_DEV_API_URL
})

api.interceptors.request.use(
  (config) => {
    const accessToken: string | null = window.localStorage.getItem('accessToken')

    const temporaryToken: string | null = window.localStorage.getItem('temporaryToken')

    if (accessToken || temporaryToken) {
      if (config.headers) {
        config.headers['Authorization'] = `Bearer ${accessToken ?? temporaryToken}`
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

//TODO: LoginInput type comes with mfa branch
export async function login(input: LoginInput): Promise<CurrentUser> {
  const response = await api.post('/login', input)

  return response.data
}

export async function sendPasswordResetEmail(input: EmailInput): Promise<unknown> {
  const response = await api.post('/email', input)

  return response.data
}

export async function resetPassword(input: PassworInput, token: string): Promise<unknown> {
  const response = await api.post(`/email/password_reset/${token}`, input)

  return response.data
}

//move this to users service?
export async function changePassword(id: number, input: PassworInput): Promise<unknown> {
  const response = await api.put(`/users/change_password/${id}`, input)

  return response.data
}

/**
 * Handles the refresh token process.
 * @deprecated Use `handleRefreshSession` instead.
 */
export async function handleRefreshToken() {
  const refreshToken = localStorage.getItem('refreshToken')

  try {
    const response = await api.post('/login/refresh-token', {
      refreshToken
    })

    const newTokens = response.data

    if (!newTokens) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
    }

    return setSession(newTokens.accessToken, newTokens.refreshToken)
  } catch (_error) {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
  }
}

export async function sendEmailVerificationMail(): Promise<void> {
  const response = await api.post('/email/verify/user')

  return response.data
}

export async function verifyUserEmailService(token: string): Promise<unknown> {
  const response = await api.post(`/email/verify/${token}`)

  return response.data
}

export async function sendMfaResetLink(input: MFAResetLinkInput): Promise<void> {
  const response = await api.post(`/email/send-mfa-reset-link`, input)

  return response.data
}

export async function resetUserMfa(token: string): Promise<void> {
  const response = await api.post(`/email/reset-mfa/${token}`)

  return response.data
}

export async function signUpService(input: SignUpInput, turnstileToken?: string): Promise<User> {
  const api = createAPIClient('/v2')

  const response = await api.post('/auth/sign-up', input, getTurnstileRequestConfig(turnstileToken))

  return response.data
}

export async function signUpByTokenService(
  input: SignUpInput,
  token: string,
  turnstileToken?: string
): Promise<User> {
  const api = createAPIClient('/v2')

  const response = await api.post(
    `/auth/sign-up/${token}`,
    input,
    getTurnstileRequestConfig(turnstileToken)
  )

  return response.data
}

export async function verifyPhoneService(config: AxiosRequestConfig = {}): Promise<User> {
  const api = createAPIClient('/v2')

  const response = await api.patch(`/auth/verify-phone`, undefined, config)

  return response.data
}

export async function verifyEmailService(config: AxiosRequestConfig = {}): Promise<User> {
  const api = createAPIClient('/v2')

  const response = await api.patch(`/auth/verify-email`, undefined, config)

  return response.data
}

export interface UpdateMfa {
  mfaType: MFAType
}

export async function updateMfaService(
  input: UpdateMfa,
  config: AxiosRequestConfig = {}
): Promise<User> {
  const api = createAPIClient('/v2')

  const response = await api.patch(`/auth/mfa`, input, config)

  return response.data
}

export default {
  login,
  // sendEmail,
  resetPassword,
  changePassword,
  sendEmailVerificationMail,
  sendMfaResetLink,
  verifyUserEmailService,
  resetUserMfa,
  sendPasswordResetEmail
}
